import dayjs from 'dayjs';
import React, { useCallback, useContext } from 'react';

import { BirthdayInput as Input } from '../../../../components/ui/Inputs/BirthdayInput';
import { useContent } from '../../../../hooks/useContent';
import { MlifeActivationContext } from '../../MlifeActivationContext';

export function BirthdayInput() {
  const { activationRequest } = useContext(MlifeActivationContext);
  const { getContentByPath } = useContent();

  const formattedDate = useCallback(() => {
    if (!activationRequest?.dateOfBirth) return '';

    return dayjs(activationRequest?.dateOfBirth, 'YYYY-MM-DD').format('MM-DD-YYYY');
  }, [activationRequest?.dateOfBirth]);

  return (
    <Input
      label={getContentByPath('mlifeActivation.accountSetupSection.fields.birthday.title')}
      id='birthDay'
      testId='birthDay'
      disabled
      aria-label={getContentByPath('mlifeActivation.accountSetupSection.fields.birthday.label')}
      hint={getContentByPath('mlifeActivation.accountSetupSection.fields.birthday.hint')}
      className={`identity__field identity__field-birthday`}
      value={formattedDate()}
      onChange={() => null}
    />
  );
}
